jQuery(function($){
    initAjaxBtn();
    function initAjaxBtn() {
    }
    
    // UTILS
    function getUrl(params) {
        if (paged == null) {
            var paged = 1;
        } else {                
            paged = parseInt(paged);
        }
        var currentUrl = window.location.href;
        var cleanedUrl = currentUrl.split('?')[0].split('page/')[0];

        var urlParams = '';
        var i = 0;

        $(params).each(function(i, element) {
            if (element.value.length) {                    
                if (i == 0) {
                    urlParams += '?' + element.name + '=' + element.value;
                } else {
                    urlParams += '&' + element.name + '=' + element.value;
                }
            }

            ++i;
        });
        var completeUrl = cleanedUrl + urlParams;

        return completeUrl;
    }

    if($('body').hasClass('page-template-actualites')){
        function loadAjaxActus(data, url){
            $.ajax({
                url: ajaxurl,
                data: data, 
                type: 'GET',
                beforeSend: function ( xhr ) {
                    $('#post-container').remove();
                    $('#onload').removeClass('d-none');                    
                },
                success: function( data ){
                    if( data ) {
                        $('#onload').addClass('d-none');
                        $('#ajax-container').html(data);
                        initAjaxBtn();
                        
                        if (url != null) {                            
                            window.history.pushState('', '', url);
                        }
                    }
                }
            });
        }
        function setParams(params, url, categorie, voie) {
            if (categorie != null && categorie.length) {
                url += '&categorie='+categorie;
                
                params.push({
                    'name': 'categorie',
                    'value': categorie
                })
            }
            if (voie != null && voie.length) {
                url += '&voie='+voie;
                
                params.push({
                    'name': 'voie',
                    'value': voie
                })
            }
            return [url, params];
        }
        
        $('form.filters').submit(function(event){
            event.preventDefault();
            
            var categorie = $('form.filters select[name="categorie"]').val();
            var voie = $('form.filters select[name="voie-d-eau"]').val();

            var motClef = '';
            
            var url = $(this)[0]['action'].split('?')[0].split('page/')[0]+'?mot-clef='+motClef;

            var params = [];            
            var paramsArray = setParams(params, url, categorie, voie);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
            var data = {
                'action': 'loadActus',
                'categorie': categorie,
                'voie': voie,
                'link': link
                };
            loadAjaxActus(data, url);

            loadmore_params.current_page = 1
        });
        
        $(document).off('click','.page-numbers li a');
        $(document).on('click','.page-numbers li a',function(e){
            e.preventDefault();
            
            var categorie = $('form.filters select[name="categorie"]').val();
            var voie = $('form.filters select[name="voie-d-eau"]').val();

            var motClef = '';
            
            var paged = $(this).attr('data-page');
            var url = $(this).attr('href').split('?')[0]+'?mot-clef='+motClef;
            
            var params = [];            
            var paramsArray = setParams(params, url, categorie, voie);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
            var data = {
                'action': 'loadActus',
                'categorie': categorie,
                'voie': voie,
                'paged': paged,
                'link': link
                };
            loadAjaxActus(data, url);
        });
        
        var paged=1;
        $(document).on('click','.loadmore',function(e){ 
            e.preventDefault();
            var action = 'loadmoreActus';
            var categorie = $('form.filters select[name="categorie"]').val();
            var voie = $('form.filters select[name="voie-d-eau"]').val();
            var button = $(this),
                data = {
                'action': action,
                'query': loadmore_params.posts,
                'page': loadmore_params.current_page,
                'categorie': categorie,
                'voie': voie
            };

            $.ajax({
                url: loadmore_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function ( xhr ) {
                    button.addClass('is-loading');
                },
                success: function( data ){
                    console.log(data);
                    if(data.replace(/\s/g, '').length) { 
                        button.removeClass('is-loading').closest('div').prev().after(data);
                        loadmore_params.current_page++;

                        if ( loadmore_params.current_page == loadmore_params.max_page ) 
                            button.remove();
                    } else {
                        button.remove();
                    }
                }
            });
        });
    }

});